// translate.directive.ts
import { isPlatformBrowser } from '@angular/common';
import {
  Directive,
  ElementRef,
  AfterViewInit,
  signal,
  PLATFORM_ID,
  Inject,
  inject,
  DestroyRef,
} from '@angular/core';
import { TranslateService } from '@app/services/translate/translate.service';
import { elementAt } from 'rxjs';

@Directive({
  selector: '[multilang]',
  providers: [],
  standalone: false,
})
export class TranslateDirective implements AfterViewInit {
  isBrowser = signal<boolean>(false);
  destroyRef = inject(DestroyRef);

  constructor(
    private el: ElementRef,
    @Inject(PLATFORM_ID) protected platformId: any,
    protected translateService: TranslateService
  ) {
    this.isBrowser.set(isPlatformBrowser(this.platformId));
  }

  ngAfterViewInit() {
    if (!this.isBrowser()) return;

    const element = this.el.nativeElement;

    // Create a TreeWalker to find all visible text nodes
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => {
        // Filter out whitespace-only nodes
        return node.textContent?.trim()
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      },
    });

    const textNodes: Text[] = [];

    let currentNode = walker.nextNode();
    while (currentNode) {
      textNodes.push(currentNode as Text);
      currentNode = walker.nextNode();
    }

    // Translate each text node individually
    textNodes.forEach((node) => {
      const originalText = node.nodeValue?.trim();
      if (originalText) {
        this.translateService.collect(originalText, (translated) => {
          if (translated?.length > 0) {
            node.textContent = translated;
          }
        });
      }
    });
  }
}
